import { http } from 'src/utils/http.util'
import { TTwoFactorStatus, TTotpSetupData } from 'src/types/two-factor'

export const TwoFactorService = {
  setupTotp: (): Promise<TTotpSetupData> => http.post('/auth/2fa/setup/totp').then((res) => res.data),

  confirmTotp: (code: string): Promise<{ backupCodes: string[] }> =>
    http.post('/auth/2fa/setup/totp/confirm', { code }).then((res) => res.data),

  setupSms: (): Promise<void> => http.post('/auth/2fa/setup/sms').then((res) => res.data),

  confirmSms: (code: string): Promise<{ backupCodes: string[] }> =>
    http.post('/auth/2fa/setup/sms/confirm', { code }).then((res) => res.data),

  getStatus: (): Promise<TTwoFactorStatus> => http.get('/auth/2fa/status').then((res) => res.data),

  disable: (password: string): Promise<{ disabled: true }> =>
    http.post('/auth/2fa/disable', { password }).then((res) => res.data),

  regenerateBackupCodes: (password: string): Promise<{ backupCodes: string[] }> =>
    http.post('/auth/2fa/backup-codes/regenerate', { password }).then((res) => res.data),

  resetUserTwoFactor: (userId: number): Promise<void> =>
    http.put(`/admin/${userId}/reset-two-factor`).then((res) => res.data),
}
